import {Component, inject, OnChanges} from '@angular/core';
import {BaseRecordTableItemComponent} from '../base-record-table-item/base-record-table-item.component';
import {PlanFactValue} from '../../../../types/records-table.types';
import {UtilityService} from '../../../../services/utility.service';

@Component({
  selector: 'app-plan-fact-item',
  standalone: false,
  templateUrl: './plan-fact-item.component.html',
  styleUrls: [
    './plan-fact-item.component.scss',
    '../base-record-table-item-styles.scss'
  ]
})
export class PlanFactItemComponent extends BaseRecordTableItemComponent implements OnChanges {
  private utilityService: UtilityService = inject(UtilityService);

  protected readonly String = String;
  protected planFactValue: PlanFactValue = { plan: 0, fact: 0 };
  protected get isBudgetColumn(): boolean {
    return ['budgetPlanFact', 'currentMonthBudgetPlanFact', 'nextMonthBudgetPlanFact'].includes(this.columnParam.key);
  }

  public ngOnChanges() {
    this.planFactValue = this.value as PlanFactValue;
  }

  protected isFactLessThanPlan(): boolean {
    return this.planFactValue?.fact < this.planFactValue?.plan;
  }

  protected formatNumberForDisplay(value: number): string {
    return this.utilityService.formatNumberForDisplay({
      value: value,
      fractional: this.columnParam.columnProperties.FRACTIONAL,
      numberSeparator: this.columnParam.columnProperties.NUMBER_SEPARATOR
    });
  }

  protected formatBudgetValue(value: number): string {
    return this.utilityService.formatBudgetValue({ value });
  }
}
